import { render, staticRenderFns } from "./tabHallFama.vue?vue&type=template&id=a326e804&scoped=true"
import script from "./tabHallFama.vue?vue&type=script&lang=js"
export * from "./tabHallFama.vue?vue&type=script&lang=js"
import style0 from "./tabHallFama.vue?vue&type=style&index=0&id=a326e804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a326e804",
  null
  
)

export default component.exports